import { Route } from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { ComponentDirtyCheckGuard } from '../../shared/guards/component-dirty-check.guard';
import { hasScopesGuard } from '../../shared/guards/has-scopes.guard';
import { hasScopesResolver } from '../../shared/resolvers/has-scopes.resolver';
import { shiftResolver } from './shift.resolver';

export const shiftRoutes: Route[] = [
  {
    path: '',
    title: _('i18n.Shift.List.Title'),
    loadComponent: () =>
      import('./shift-list/shift-list.component').then(
        (m) => m.ShiftListComponent,
      ),
    resolve: { hasWriteScope: hasScopesResolver(['shifts:write']) },
  },
  {
    path: 'create',
    title: _('i18n.Shift.Create.Title'),
    loadComponent: () =>
      import('./shift-create/shift-create.component').then(
        (m) => m.ShiftCreateComponent,
      ),
    canDeactivate: [ComponentDirtyCheckGuard],
    canActivate: [hasScopesGuard(['shifts:write'])],
  },
  {
    path: ':shiftId',
    children: [
      {
        path: 'detail',
        resolve: {
          shift: shiftResolver,
          hasWriteScope: hasScopesResolver(['shifts:write']),
        },
        loadComponent: () =>
          import('./shift-detail/shift-detail.component').then(
            (m) => m.ShiftDetailComponent,
          ),
      },
      {
        path: 'edit',
        resolve: { shift: shiftResolver },
        loadComponent: () =>
          import('./shift-edit/shift-edit.component').then(
            (m) => m.ShiftEditComponent,
          ),
        canActivate: [hasScopesGuard(['shifts:write'])],
        canDeactivate: [ComponentDirtyCheckGuard],
      },
    ],
  },
];
